// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__2VpMf","navigationbar":"Header_navigationbar__3WmOa","navbar_item":"Header_navbar_item__2sOaz"};